import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, contracterActions } from '../../../store/actions'
import Input from '../../../module/input'
import PopupAddGoods from '../PopupAddItems'
import history from '../../../route/history'
import moment from 'moment'
import { commons } from '../../../hook/common'
import { Link } from 'react-router-dom'

/**
 * 구매확인서 2단계 / 구매물품 목록
 */
const CertificateStep02 = (props) => {
  const [sumInfo, setSumInfo] = useState({})
  const [docid, setDocid] = useState()
  const [goodsList, setGoodsList] = useState(props.stepData)
  const [showAddGoods, setShowAddGoods] = useState(false)

  /**
   * 페이지 진입
   */
  useEffect(() => {
    let id = props.search?.split('=')[1]
    let key = props.search?.split('=')[0]

    if (id && key === '?id') {
      let data = JSON.parse(sessionStorage.getItem(id))

      if (!data || !data.step1.splyprtnum || data?.step1?.splyprtnum?.length <= 0) {
        history.replace('/service/apply/1?id=' + id)
        return
      }

      setDocid(id)
      data?.step2 && setGoodsList(data.step2)

      if (data.step2?.length > 0) {
        changeSumInfo(data.step2)
      }
    } else {
      history.replace('/service/apply/1')
    }
  }, [])

  /**
   * 데이터 갱신
   */
  useEffect(() => {
    if (props.isCalled === true) {
      setGoodsList(props.stepData)
      if (props.stepData?.length > 0) {
        changeSumInfo(props.stepData)
      }
    }
    props.setCalled(false)
  }, [props?.isCalled])

  const changeSumInfo = (list) => {
    let obj = sumInfo
    obj.totamtcur = list[0]?.totamtcur
    let cnt = 0
    let amt = 0

    list.map((item) => {
      item?.gramt && (amt += item.gramt)
      item?.grcnt && (cnt += item.grcnt)
      return true
    })

    obj.amount = commons.addComma(amt)
    obj.count = commons.addComma(cnt)

    console.log(obj)
    setSumInfo(obj)
  }
  /**
   * 금액단위 변경 처리
   */
  const onChangeCurrency = (e) => {
    const { name, value } = e.target

    if (goodsList[0]?.totamtcur?.length > 0 && goodsList[0]?.totamtcur !== value) {
      return props.confirm({
        title: '확인',
        message: '총금액 단위 변경시 구매물품 목록 금액 단위가 모두 변경됩니다.\n변경하시겠습니까?',
        params: {
          type: 'confirm',
          callback: () => {
            props.updateCurrency(docid, value)
          },
        },
      })
    }

    setSumInfo({
      ...sumInfo,
      [name]: value,
    })
  }

  /**
   * 물품추가 팝업 호출
   * @returns {*}
   */
  const openAddGoods = () => {
    if (!sumInfo.totamtcur || sumInfo.totamtcur?.length <= 0) {
      return props.error({ message: '통화코드를 선택해주세요.' })
    }
    setShowAddGoods(true)
  }

  return (
    <React.Fragment>
      {showAddGoods && <PopupAddGoods currency={sumInfo?.totamtcur || ''} onClose={() => setShowAddGoods(false)} docid={docid} />}

      <div className="cardBox m-t-20">
        <div className="step-title m-b-10">
          구매물품 목록<span className="required">*</span>
          <span>(구매완료· 기재의 내용)</span>
          <p className="des">: 총금액 통화코드를 먼저 선택하신 후 구매물품 목록을 등록하시면 합계가 자동 계산됩니다.</p>
        </div>
        <div className="table col">
          <div className="row">
            <div className="cell th">총 수량</div>
            <div className="cell ">
              <Input
                id="totalCnt"
                name="totalCnt"
                type="text"
                inputTitle={'총수량'}
                value={sumInfo?.count || ''}
                readOnly={true}
                flow={`${window.innerWidth >= 767 ? 'left' : 'up'}`}
                className="form-control input-text disabled"
              />
            </div>
          </div>
          <div className="row">
            <div className="cell th">총 금액</div>
            <div className="cell ">
              <div className="dis-flex cellDiv ">
                <div className="select-wrap W-15">
                  <select id="totamtcur" name="totamtcur" value={sumInfo.totamtcur || ''} onChange={onChangeCurrency}>
                    <option value="">통화코드</option>
                    <option value="USD">USD</option>
                    <option value="KRW">KRW</option>
                  </select>
                </div>
                <Input
                  id="totalAmount"
                  name="totalAmount"
                  type="text"
                  inputTitle={'총 금액'}
                  value={sumInfo?.amount || ''}
                  readOnly={true}
                  flow={`${window.innerWidth >= 767 ? 'left' : 'up'}`}
                  className="form-control input-text disabled"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="title-btn m-t-30">
          <div className="guide">무체물과 용역의 HS부호는 '9999999999'입력</div>
          <div className="dis-flex ">
            <span className="totalPage w-50">총 {goodsList?.length}건</span>
            <div className="flex-r w-50">
              <button className="btn btn-white" onClick={openAddGoods}>
                구매물품 목록 등록/수정
              </button>
            </div>
          </div>
        </div>
        <div className="table">
          <div className="row header border">
            <div className="cell w-10">HS부호</div>
            <div className="cell ">품명</div>
            <div className="cell w-10">규격</div>
            <div className="cell w-10">수량</div>
            <div className="cell w-10">구매일</div>
            <div className="cell w-7">
              단가
              {sumInfo?.totamtcur?.length > 0 && (
                <>
                  <br />({sumInfo?.totamtcur})
                </>
              )}
            </div>
            <div className="cell w-7">
              금액
              {sumInfo?.totamtcur?.length > 0 && (
                <div>
                  <br />({sumInfo?.totamtcur})
                </div>
              )}
            </div>
          </div>
          {goodsList?.length > 0 ? (
            goodsList?.map((goods, index) => {
              return (
                <div className="row" key={index}>
                  <div className="cell" data-title={'HS부호'}>
                    {goods?.hsCd}
                  </div>
                  <div className="cell" data-title={'품명'}>
                    {goods?.itemnm}
                  </div>
                  <div className="cell" data-title={'규격'}>
                    {goods?.itemdeftxt}
                  </div>
                  <div className="cell" data-title={'수량'}>
                    {goods?.grcnt && commons.addComma(goods.grcnt)}
                  </div>
                  <div className="cell" data-title={'구매일'}>
                    {goods?.crtYmd && moment(goods.crtYmd).format('YYYY-MM-DD')}
                  </div>
                  <div className="cell" data-title={'단가'}>
                    {goods?.baseAmt && commons.addComma(goods.baseAmt)}
                  </div>
                  <div className="cell" data-title={'금액'}>
                    {goods?.gramt && commons.addComma(goods.gramt)}
                  </div>
                </div>
              )
            })
          ) : (
            <div className="row noData">
              <div className="cell">등록된 자료가 없습니다.</div>
            </div>
          )}
        </div>
      </div>

      <div className="detail-btn">
        <button className="btn btn-white float-l" onClick={props.doDelete}>
          삭제
        </button>
        <button className="btn btn-blue" onClick={() => history.goBack()}>
          이 전
        </button>
        <button className="btn btn-blue" onClick={props.goStepNext}>
          다 음
        </button>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    stepData: state.contracter?.data?.step2,
    totalData: state.contracter.data,
    isCalled: state.contracter.isCalled,
  }
}

const actionCreators = {
  setCalled: contracterActions.setCalled,
  error: alertActions.error,
  confirm: alertActions.confirm,
  updateCurrency: contracterActions.updateCurrency,
}

export default connect(mapStateToProps, actionCreators)(CertificateStep02)
